import React from 'react';
import { Button, Container } from 'react-bootstrap';

export const AppErrorTest = foo => (
  <Container fluid>
    <p>
      <Button>Rise error {foo}</Button>
    </p>
  </Container>
);

export default AppErrorTest;
